import axios, { AxiosResponse } from 'axios';
import { BulkUploadSummary } from '../models/bulkUploadSummary';

const baseUrl = '/bulkPayments';

const uploadFile = (
  file: FormData
): Promise<AxiosResponse<BulkUploadSummary>> =>
  axios.post<BulkUploadSummary>(`${baseUrl}/upload`, file);

const exportErrors = (fileId: string): Promise<AxiosResponse<string>> =>
  axios.get<string>(`${baseUrl}/export/errors/${fileId}`, {
    responseType: 'blob'
  });

const submitPayments = (fileId: string): Promise<AxiosResponse<void>> =>
  axios.get<void>(`${baseUrl}/submit/${fileId}`);

const errorHistory = (): Promise<
  AxiosResponse<{ uuid: string; fileName: string }[]>
> => axios.get<{ uuid: string; fileName: string }[]>(`${baseUrl}/error-files`);

const deleteError = (uuid: string): Promise<AxiosResponse<void>> =>
  axios.delete<void>(`${baseUrl}/error-file/${uuid}`);

export const bulkPaymentsService = {
  uploadFile,
  exportErrors,
  submitPayments,
  errorHistory,
  deleteError
};
